module.exports = __webpack_public_path__ + "img/waiter-place-order-mobile.d5c92e41.png";